export const CardioIcon = ({ cardioType }) => {
  if (cardioType === "Stairmaster") return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="11" y="4"  width="6" height="2.5" rx="0.5" fill="#9dc4e8"/>
      <rect x="7"  y="7"  width="6" height="2.5" rx="0.5" fill="#9dc4e8"/>
      <rect x="3"  y="10" width="6" height="2.5" rx="0.5" fill="#9dc4e8"/>
      <rect x="3"  y="13" width="14" height="1.5" rx="0.5" fill="#9dc4e8" opacity="0.35"/>
    </svg>
  );
  if (cardioType === "Cycling") return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="5"  cy="14" r="3" stroke="#9dc4e8" strokeWidth="1.4" fill="none"/>
      <circle cx="15" cy="14" r="3" stroke="#9dc4e8" strokeWidth="1.4" fill="none"/>
      <path d="M5 14 L10 14 L10 9 M10 14 L15 14 M10 9 L15 10 L15 14" stroke="#9dc4e8" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <path d="M15 10 L17 9 M15 10 L17 11" stroke="#9dc4e8" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M8.5 8.5 L11 8.5" stroke="#9dc4e8" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
  if (cardioType === "Swimming") return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="14.5" cy="5" r="1.5" fill="#9dc4e8"/>
      <path d="M4 9 Q6 7 8 9 Q10 11 12 9 Q14 7 16 9" stroke="#9dc4e8" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      <path d="M4 12.5 Q6 10.5 8 12.5 Q10 14.5 12 12.5 Q14 10.5 16 12.5" stroke="#9dc4e8" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.6"/>
      <path d="M12 6 L9 9" stroke="#9dc4e8" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M13 7.5 L11 10" stroke="#9dc4e8" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    </svg>
  );
  if (cardioType === "Rowing") return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="16.5" cy="11.5" r="2.2" stroke="#9dc4e8" strokeWidth="1.3" fill="none"/>
      <circle cx="16.5" cy="11.5" r="0.6" fill="#9dc4e8"/>
      <path d="M3 12 L14.5 12" stroke="#9dc4e8" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M3.5 12 L2.5 15" stroke="#9dc4e8" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M14 12 L15 15" stroke="#9dc4e8" strokeWidth="1.2" strokeLinecap="round"/>
      <rect x="7" y="10.8" width="4" height="1.4" rx="0.3" fill="#9dc4e8"/>
      <rect x="5" y="7.5"  width="5" height="1"   rx="0.5" fill="#9dc4e8"/>
      <path d="M10 8 L14.5 11" stroke="#9dc4e8" strokeWidth="0.8" strokeLinecap="round" opacity="0.6"/>
    </svg>
  );
  if (cardioType === "HIIT") return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M11.5 2 L7 10 L10.5 10 L8.5 18 L14 9 L10.5 9 Z" fill="#9dc4e8"/>
    </svg>
  );
  // Running (default)
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="13" cy="3" r="1.6" fill="#9dc4e8"/>
      <path d="M12.5 4.6 L10 9" stroke="#9dc4e8" strokeWidth="1.7" strokeLinecap="round"/>
      <path d="M12 6 L14 7 L15 5.5" stroke="#9dc4e8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 6 L9 7 L7.5 9.5" stroke="#9dc4e8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 9 L13 11 L12.5 14.5" stroke="#9dc4e8" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 9 L8 12.5 L6 15.5" stroke="#9dc4e8" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
